@if (inQueue !== null) {
  <div class="container">
    <div class="header">
      <span class="title">{{ 'quizai.modal.title' | translate | async }} </span>
      <span class="topic">{{ taskForm.value.topic }}</span>
      @if (completedSuccess !== null) {
        <button class="close" mat-icon-button [matTooltip]="'general.buttons.close' | translate | async" color="warn" (click)="close()"><mat-icon>close</mat-icon></button>
      }
    </div>
    <div class="content">
      <div class="status" [ngClass]="quizStatus">{{ quizStatus }}</div>
      <div class="details">
        @if (inQueue === true) {
          <span>{{ 'quizai.modal.in_queue' | translate:queuePosition.toString() | async }}</span>
        }
        @if (inQueue === false) {
          <span>{{ quizMsg }}</span>
        }
      </div>
    </div>
    <div class="actions">
      <button mat-icon-button [matTooltip]="'general.buttons.details' | translate | async" color="warn" (click)="goToGen()"><mat-icon>info</mat-icon></button>
      @if (completedSuccess === null) {
        <button mat-icon-button [matTooltip]="'general.buttons.cancel' | translate | async" color="warn" (click)="cancelGen()"><mat-icon>cancel</mat-icon></button>
      } @else if (completedSuccess === true) {
        <button mat-icon-button [matTooltip]="'general.buttons.edit' | translate | async" color="warn" (click)="editGame()"><mat-icon>settings</mat-icon></button>
        <button mat-icon-button [matTooltip]="'general.buttons.play' | translate | async" color="warn" (click)="startGame()"><mat-icon>play_arrow</mat-icon></button>
      }
    </div>
  </div>
}
